import { getDecodedConsulData } from '@shared/lib/consul'
import { DisabledServiceType } from '../model/tsp.types'

export const fetchIsServiceDisabledById = async (id: string) => {
  const data = await getDecodedConsulData<{ disabledServices: DisabledServiceType[] }>(
    '/services/disabled-services/value'
  )

  return data.disabledServices.includes(id)
}
